// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/managed-entities/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        readinessCheck: build.query<ReadinessCheckApiResponse, ReadinessCheckApiArg>({
            query: () => ({ url: `/health/readiness` }),
        }),
        livenessCheck: build.query<LivenessCheckApiResponse, LivenessCheckApiArg>({
            query: () => ({ url: `/health/liveness` }),
        }),
        listGroups: build.query<ListGroupsApiResponse, ListGroupsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups`,
                params: {
                    search: queryArg.search,
                    filter: queryArg.filter,
                    include: queryArg.include,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createGroup: build.mutation<CreateGroupApiResponse, CreateGroupApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups`,
                method: "POST",
                body: queryArg.createGroupDto,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getGroup: build.query<GetGroupApiResponse, GetGroupApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups/${queryArg.groupId}`,
                params: { include: queryArg.include },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteGroup: build.mutation<DeleteGroupApiResponse, DeleteGroupApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups/${queryArg.groupId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateGroup: build.mutation<UpdateGroupApiResponse, UpdateGroupApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups/${queryArg.groupId}`,
                method: "PATCH",
                body: queryArg.updateGroupDto,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        batchAddGroups: build.mutation<BatchAddGroupsApiResponse, BatchAddGroupsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups/batch-add`,
                method: "POST",
                body: queryArg.batchAddGroupsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listFieldValues: build.query<ListFieldValuesApiResponse, ListFieldValuesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups/${queryArg.groupId}/field-values`,
                params: {
                    filter: queryArg.filter,
                    include: queryArg.include,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        batchSetFieldValues: build.mutation<BatchSetFieldValuesApiResponse, BatchSetFieldValuesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups/${queryArg.groupId}/field-values`,
                method: "POST",
                body: queryArg.batchSetFieldValuesDto,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteAllFieldValues: build.mutation<DeleteAllFieldValuesApiResponse, DeleteAllFieldValuesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/groups/${queryArg.groupId}/field-values`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listEntityTypes: build.query<ListEntityTypesApiResponse, ListEntityTypesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-types`,
                params: { page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createEntityType: build.mutation<CreateEntityTypeApiResponse, CreateEntityTypeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-types`,
                method: "POST",
                body: queryArg.createEntityTypeDto,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getEntityType: build.query<GetEntityTypeApiResponse, GetEntityTypeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-types/${queryArg.entityTypeId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateEntityType: build.mutation<UpdateEntityTypeApiResponse, UpdateEntityTypeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-types/${queryArg.entityTypeId}`,
                method: "PATCH",
                body: queryArg.updateEntityTypeDto,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteEntityType: build.mutation<DeleteEntityTypeApiResponse, DeleteEntityTypeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-types/${queryArg.entityTypeId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        triggerDiscover: build.mutation<TriggerDiscoverApiResponse, TriggerDiscoverApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-types/${queryArg.entityTypeId}/discover`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listEntityTypeFields: build.query<ListEntityTypeFieldsApiResponse, ListEntityTypeFieldsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-type-fields`,
                params: { filter: queryArg.filter, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        batchAddEntityTypeFields: build.mutation<BatchAddEntityTypeFieldsApiResponse, BatchAddEntityTypeFieldsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-type-fields/batch-add`,
                method: "POST",
                body: queryArg.batchAddEntityTypeFieldsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        removeEntityTypeField: build.mutation<RemoveEntityTypeFieldApiResponse, RemoveEntityTypeFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-type-fields/${queryArg.entityTypeFieldId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listEntityFieldValues: build.query<ListEntityFieldValuesApiResponse, ListEntityFieldValuesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-field-values`,
                params: {
                    filter: queryArg.filter,
                    include: queryArg.include,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        batchUpsertEntityFieldValues: build.mutation<BatchUpsertEntityFieldValuesApiResponse, BatchUpsertEntityFieldValuesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-field-values/batch-upsert`,
                method: "POST",
                body: queryArg.batchUpsertFieldValuesRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        batchDeleteEntityFieldValues: build.mutation<BatchDeleteEntityFieldValuesApiResponse, BatchDeleteEntityFieldValuesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-field-values/batch-delete`,
                method: "POST",
                body: queryArg.batchDeleteFieldValuesRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        mergeAliases: build.mutation<MergeAliasesApiResponse, MergeAliasesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-alias/${queryArg.entityTypeId}/batch-replace`,
                method: "POST",
                body: queryArg.items,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteAliases: build.mutation<DeleteAliasesApiResponse, DeleteAliasesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-alias/${queryArg.entityTypeId}/batch-delete`,
                method: "POST",
                body: queryArg.aliasIds,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        addAliases: build.mutation<AddAliasesApiResponse, AddAliasesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/entity-alias/${queryArg.entityTypeId}/batch-add`,
                method: "POST",
                body: queryArg.items,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        batchAddNodes: build.mutation<BatchAddNodesApiResponse, BatchAddNodesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/nodes/batch-add`,
                method: "POST",
                body: queryArg.batchAddNodesRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteNode: build.mutation<DeleteNodeApiResponse, DeleteNodeApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/nodes/${queryArg.nodeId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateNodeMetadata: build.mutation<UpdateNodeMetadataApiResponse, UpdateNodeMetadataApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/nodes/${queryArg.nodeId}`,
                method: "PATCH",
                body: queryArg.updateNodeMetadataRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        batchMoveNodes: build.mutation<BatchMoveNodesApiResponse, BatchMoveNodesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/nodes/batch-move`,
                method: "PATCH",
                body: queryArg.batchMoveNodesRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getNodePath: build.query<GetNodePathApiResponse, GetNodePathApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/nodes/path`,
                params: { filter: queryArg.filter },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listNodes: build.query<ListNodesApiResponse, ListNodesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/nodes`,
                params: {
                    filter: queryArg.filter,
                    include: queryArg.include,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ReadinessCheckApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type ReadinessCheckApiArg = void;
export type LivenessCheckApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type LivenessCheckApiArg = void;
export type ListGroupsApiResponse = 
/** status 200 Successful Response */ GroupPageResponse;
export type ListGroupsApiArg = {
    /** Fuzzy search on group name and note. Results are ranked by relevance, then by newest first. */
    search?: string | null;
    filter?: {
        /** Return only groups scoped to this entity type. */
        entity_type_id?: string | null;
    };
    /** Related resources to side-load into `included`. 'aliases' and 'entity_field_values' require filter[entity_type_id]; 'entity_field_values' side-loads values and active field columns; 'root_node' side-loads each group's root node. */
    include?: GroupIncludeType[];
    page?: {
        /** Number of items per page (max 1000). */
        limit?: number;
        /** Offset of the first item to return. */
        offset?: number;
    };
};
export type CreateGroupApiResponse = 
/** status 201 Successful Response */ GroupResponse;
export type CreateGroupApiArg = {
    createGroupDto: CreateGroupDto;
};
export type GetGroupApiResponse = 
/** status 200 Successful Response */ GroupWithIncludesResponse;
export type GetGroupApiArg = {
    groupId: string;
    /** Related resources to side-load into `included`. 'root_node' side-loads the group's root node. */
    include?: GroupIncludeType[];
};
export type DeleteGroupApiResponse = void;
export type DeleteGroupApiArg = {
    groupId: string;
};
export type UpdateGroupApiResponse = 
/** status 200 Successful Response */ GroupResponse;
export type UpdateGroupApiArg = {
    groupId: string;
    updateGroupDto: UpdateGroupDto;
};
export type BatchAddGroupsApiResponse = 
/** status 200 Successful Response */ BatchAddGroupsResultResponse;
export type BatchAddGroupsApiArg = {
    batchAddGroupsRequest: BatchAddGroupsRequest;
};
export type ListFieldValuesApiResponse = 
/** status 200 Successful Response */ EntityFieldValuePageResponse;
export type ListFieldValuesApiArg = {
    groupId: string;
    filter?: {
        /** When set, return only the cells for these entity_type_field (column) ids. Accepts a single UUID or a comma-separated list of UUIDs with no whitespace (e.g. `id1,id2`, up to 100 ids). A single group plus a single field id 404s if that cell is missing; multiple ids return the matching stored cells. entity_type_field_id is the primary key (uuid) of the entity_type_field row representing the group column, not unified_field_id. */
        entity_type_field_id?: string | null;
    };
    /** Related resources to side-load into `included`. `entity-type-fields` includes the backing field definitions. */
    include?: FieldValueIncludeType[];
    page?: {
        /** Number of items per page (max 1000). */
        limit?: number;
        /** Offset of the first item to return. */
        offset?: number;
    };
};
export type BatchSetFieldValuesApiResponse = 
/** status 200 Successful Response */ EntityFieldValueBatchSetResponse;
export type BatchSetFieldValuesApiArg = {
    groupId: string;
    batchSetFieldValuesDto: BatchSetFieldValuesDto;
};
export type DeleteAllFieldValuesApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteAllFieldValuesApiArg = {
    groupId: string;
};
export type ListEntityTypesApiResponse = 
/** status 200 Successful Response */ EntityTypePageResponse;
export type ListEntityTypesApiArg = {
    page?: {
        /** Number of items per page (max 1000). */
        limit?: number;
        /** Offset of the first item to return. */
        offset?: number;
    };
};
export type CreateEntityTypeApiResponse = 
/** status 201 Successful Response */ EntityTypeResponse;
export type CreateEntityTypeApiArg = {
    createEntityTypeDto: CreateEntityTypeDto;
};
export type GetEntityTypeApiResponse = 
/** status 200 Successful Response */ EntityTypeResponse;
export type GetEntityTypeApiArg = {
    entityTypeId: string;
};
export type UpdateEntityTypeApiResponse = 
/** status 200 Successful Response */ EntityTypeResponse;
export type UpdateEntityTypeApiArg = {
    entityTypeId: string;
    updateEntityTypeDto: UpdateEntityTypeDto;
};
export type DeleteEntityTypeApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteEntityTypeApiArg = {
    entityTypeId: string;
};
export type TriggerDiscoverApiResponse = 
/** status 202 Successful Response */ any;
export type TriggerDiscoverApiArg = {
    entityTypeId: string;
};
export type ListEntityTypeFieldsApiResponse = 
/** status 200 Successful Response */ EntityTypeFieldPageResponse;
export type ListEntityTypeFieldsApiArg = {
    filter?: {
        /** Entity type whose active fields to list (required). */
        entity_type_id?: string;
    };
    page?: {
        /** Number of items per page (max 1000). */
        limit?: number;
        /** Offset of the first item to return. */
        offset?: number;
    };
};
export type BatchAddEntityTypeFieldsApiResponse = 
/** status 200 Successful Response */ BatchAddEntityTypeFieldsResultResponse;
export type BatchAddEntityTypeFieldsApiArg = {
    batchAddEntityTypeFieldsRequest: BatchAddEntityTypeFieldsRequest;
};
export type RemoveEntityTypeFieldApiResponse = 
/** status 204 Successful Response */ void;
export type RemoveEntityTypeFieldApiArg = {
    entityTypeFieldId: string;
};
export type ListEntityFieldValuesApiResponse = 
/** status 200 Successful Response */ EntityFieldValuePageResponse;
export type ListEntityFieldValuesApiArg = {
    filter?: {
        /** Group (entity instance) ids whose stored field values to list. Required. Accepts a single UUID or a comma-separated list of UUIDs with no whitespace (e.g. `id1,id2`, up to 100 ids). Missing groups are omitted. */
        group_id?: string;
        /** When set, return only the cells for these entity_type_field (column) ids. Accepts a single UUID or a comma-separated list of UUIDs with no whitespace (e.g. `id1,id2`, up to 100 ids). A single group plus a single field id 404s if that cell is missing; multiple ids return the matching stored cells. entity_type_field_id is the primary key (uuid) of the entity_type_field row representing the group column, not unified_field_id. */
        entity_type_field_id?: string | null;
    };
    /** Related resources to side-load into `included`. `entity-type-fields` includes the backing field definitions. */
    include?: FieldValueIncludeType[];
    page?: {
        /** Number of items per page (max 1000). */
        limit?: number;
        /** Offset of the first item to return. */
        offset?: number;
    };
};
export type BatchUpsertEntityFieldValuesApiResponse = 
/** status 200 Successful Response */
EntityFieldValueBatchUpsertResultResponse | /** status 207 Multi-Status */ EntityFieldValueBatchUpsertResultResponse;
export type BatchUpsertEntityFieldValuesApiArg = {
    batchUpsertFieldValuesRequest: BatchUpsertFieldValuesRequest;
};
export type BatchDeleteEntityFieldValuesApiResponse = 
/** status 200 Successful Response */ EntityFieldValueBatchDeleteResultResponse;
export type BatchDeleteEntityFieldValuesApiArg = {
    batchDeleteFieldValuesRequest: BatchDeleteFieldValuesRequest;
};
export type MergeAliasesApiResponse = any;
export type MergeAliasesApiArg = {
    entityTypeId: string;
    items: GroupAliasesItem[];
};
export type DeleteAliasesApiResponse = 
/** status 202 Successful Response */ any;
export type DeleteAliasesApiArg = {
    entityTypeId: string;
    aliasIds: string[];
};
export type AddAliasesApiResponse = any;
export type AddAliasesApiArg = {
    entityTypeId: string;
    items: GroupAliasesItem[];
};
export type BatchAddNodesApiResponse = 
/** status 200 Successful Response */ BatchAddResultResponse;
export type BatchAddNodesApiArg = {
    batchAddNodesRequest: BatchAddNodesRequest;
};
export type DeleteNodeApiResponse = void;
export type DeleteNodeApiArg = {
    nodeId: string;
};
export type UpdateNodeMetadataApiResponse = 
/** status 200 Successful Response */ NodeResponse;
export type UpdateNodeMetadataApiArg = {
    nodeId: string;
    updateNodeMetadataRequest: UpdateNodeMetadataRequest;
};
export type BatchMoveNodesApiResponse = 
/** status 204 Successful Response */ void;
export type BatchMoveNodesApiArg = {
    batchMoveNodesRequest: BatchMoveNodesRequest;
};
export type GetNodePathApiResponse = 
/** status 200 Successful Response */ NodePathResponse;
export type GetNodePathApiArg = {
    filter?: {
        /** UUID of the group containing the node. */
        group_id?: string;
        /** Resource type of the node. Allowed values: `ticket`, `ticket_v2`, `document`. */
        resource_type?: "ticket" | "ticket_v2" | "document";
        /** Unique identifier of the upstream resource. */
        resource_id?: string;
    };
};
export type ListNodesApiResponse = 
/** status 200 Successful Response */ NodePageResponse;
export type ListNodesApiArg = {
    filter?: {
        /** **Pattern: by_resource** — Must be used together with filter[resource_id]. Returns nodes matching the given resource type and ID. Allowed values: `ResourceType.TICKET`, `ResourceType.TICKET_V2`, `ResourceType.DOCUMENT`. */
        resource_type?: ("ticket" | "ticket_v2" | "document") | null;
        /** **Pattern: by_resource** — Must be used together with filter[resource_type]. Returns nodes matching the given resource type and ID(s). Accepts a single ID or a comma-separated list of IDs (e.g. `id1,id2,id3`, up to 1000 ids) to resolve group membership for many resources in one call. */
        resource_id?: string | null;
        /** **Pattern: by_parent** — Cannot be combined with other filters. Returns direct children of the specified parent node. */
        parent_node_id?: string | null;
        /** **Pattern: by_group** — Cannot be combined with other filters. Returns all nodes belonging to the specified group. */
        group_id?: string | null;
    };
    /** Related resources to include in the response. */
    include?: NodeIncludeType[];
    page?: {
        /** Number of items per page (max 1000). */
        limit?: number;
        /** Offset of the first item to return. */
        offset?: number;
    };
};
export type CheckResult = {
    name: string;
    passed: boolean;
    details?: string | null;
};
export type HealthcheckReport = {
    healthy: boolean;
    checks: CheckResult[];
};
export type GroupAttributes = {
    client_id: number;
    created_at: string | null;
    created_by: number | null;
    entity_type_id: string | null;
    name: string;
    note: string | null;
    nodes_count?: number | null;
    updated_at: string | null;
};
export type JsonApiResourceIdentifier = {
    type: string;
    id: string;
};
export type JsonApiRelationship = {
    data?: JsonApiResourceIdentifier | JsonApiResourceIdentifier[] | null;
};
export type GroupRelationships = {
    root_node?: JsonApiRelationship | null;
    entity_field_values?: JsonApiRelationship | null;
};
export type GroupResource = {
    type?: "groups";
    id: string;
    attributes: GroupAttributes;
    relationships?: GroupRelationships | null;
};
export type AliasItem = {
    /** Alias row id — pass this to `batch-delete`. */
    id: string;
    /** The alias variant that resolves to the group. */
    value: string;
};
export type AliasAttributes = {
    canonical_name: string;
    aliases: AliasItem[];
};
export type AliasResource = {
    type?: "entity_aliases";
    id: string;
    attributes: AliasAttributes;
    relationships?: {
        [key: string]: JsonApiRelationship;
    } | null;
};
export type ResourceType = "group" | "ticket" | "ticket_v2" | "document";
export type NodeAttributes = {
    resource_type: ResourceType;
    resource_id: string;
    group_id: string | null;
    parent_node_id: string | null;
    is_parent?: boolean | null;
    metadata?: {
        [key: string]: any;
    } | null;
    created_at: string | null;
    updated_at: string | null;
};
export type NodeRelationships = {
    group?: JsonApiRelationship | null;
};
export type NodeResource = {
    type?: "nodes";
    id: string;
    attributes: NodeAttributes;
    relationships?: NodeRelationships | null;
};
export type EntityFieldValueAttributes = {
    group_id: string;
    /** entity_type_field_id is the primary key (uuid) of the entity_type_field row representing the group column, not unified_field_id. */
    entity_type_field_id: string;
    /** Arbitrary JSON value stored in PostgreSQL JSONB and returned unchanged. Unified Fields values commonly use the shown data envelope. */
    value: any;
    created_at: string | null;
    updated_at: string | null;
};
export type EntityFieldValueRelationships = {
    entity?: JsonApiRelationship | null;
    entity_type_field?: JsonApiRelationship | null;
};
export type EntityFieldValueResource = {
    type?: "entity_field_values";
    id: string;
    attributes: EntityFieldValueAttributes;
    relationships?: EntityFieldValueRelationships | null;
};
export type PageMeta = {
    offset: number;
    limit: number;
    count: number;
    total: number;
};
export type PageLinks = {
    first: string;
    last?: string | null;
    prev?: string | null;
    next?: string | null;
};
export type GroupPageResponse = {
    data: GroupResource[];
    included?: (AliasResource | NodeResource | EntityFieldValueResource)[] | null;
    meta: PageMeta;
    links: PageLinks;
};
export type JsonApiErrorSource = {
    pointer: string;
};
export type ErrorData = {
    code: string;
    detail: string;
    status: string;
    title: string;
    error_key?: string | null;
    params?: {
        [key: string]: any;
    } | null;
    source?: JsonApiErrorSource | null;
};
export type ErrorResponse = {
    errors: ErrorData[];
};
export type GroupIncludeType = "aliases" | "root_node" | "entity_field_values";
export type GroupResponse = {
    data: GroupResource;
};
export type CreateGroupDto = {
    /** Display name for the group (1–500 chars). */
    name: string;
    /** Optional note or description (max 2000 chars). */
    note?: string | null;
};
export type GroupWithIncludesResponse = {
    data: GroupResource;
    included?: NodeResource[] | null;
};
export type UpdateGroupDto = {
    /** New display name (1–500 chars). Omit to leave unchanged. */
    name?: string | null;
    /** New note (max 2000 chars). Omit to leave unchanged. */
    note?: string | null;
};
export type BatchAddGroupResultAttributes = {
    name: string;
};
export type BatchAddGroupResultResource = {
    type?: "groups";
    id: string;
    attributes: BatchAddGroupResultAttributes;
    relationships?: null;
};
export type BatchAddGroupsResultResponse = {
    data: BatchAddGroupResultResource[];
};
export type BatchAddGroupsRequest = {
    /** Entity type the groups belong to. */
    entity_type_id: string;
    /** Group names to get-or-create (max 1000). */
    names?: string[];
};
export type EntityTypeFieldAttributes = {
    entity_type_id: string;
    unified_field_id: string;
    is_active: boolean;
};
export type EntityTypeFieldResource = {
    type?: "entity_type_fields";
    id: string;
    attributes: EntityTypeFieldAttributes;
    relationships?: {
        [key: string]: JsonApiRelationship;
    } | null;
};
export type EntityFieldValuePageResponse = {
    data: EntityFieldValueResource[];
    included?: EntityTypeFieldResource[] | null;
    meta: PageMeta;
    links: PageLinks;
};
export type FieldValueIncludeType = "entity-type-fields";
export type EntityFieldValueBatchSetResponse = {
    data: EntityFieldValueResource[];
};
export type BatchSetFieldValuesItem = {
    /** entity_type_field_id is the primary key (uuid) of the entity_type_field row representing the group column, not unified_field_id. */
    entity_type_field_id: string;
    /** Arbitrary JSON value stored in PostgreSQL JSONB and returned unchanged. Unified Fields values commonly use the shown data envelope. */
    value: any;
};
export type BatchSetFieldValuesDto = {
    /** Field values to set (1-100 items). */
    items: BatchSetFieldValuesItem[];
};
export type GroupingMode = "discover" | "curated" | "manual";
export type JobStatus = "pending" | "processing" | "complete" | "failed";
export type EntityTypeAttributes = {
    name: string;
    description: string | null;
    is_system: boolean;
    grouping_uf_field_id: string | null;
    grouping_mode: GroupingMode | null;
    job_status: JobStatus | null;
};
export type EntityTypeResource = {
    type?: "entity_types";
    id: string;
    attributes: EntityTypeAttributes;
    relationships?: {
        [key: string]: JsonApiRelationship;
    } | null;
};
export type JsonApiResource = {
    type: string;
    id: string;
    attributes: any;
    relationships?: {
        [key: string]: JsonApiRelationship;
    } | null;
};
export type EntityTypePageResponse = {
    data: EntityTypeResource[];
    included?: JsonApiResource[] | null;
    meta: PageMeta;
    links: PageLinks;
};
export type EntityTypeResponse = {
    data: EntityTypeResource;
};
export type CreateEntityTypeDto = {
    /** Display name for the entity type (1–255 chars). */
    name: string;
    /** Optional description (max 500 chars). */
    description?: string | null;
    /** Unified field used for grouping. */
    grouping_uf_field_id: string;
};
export type UpdateEntityTypeDto = {
    /** Optional description (max 500 chars). */
    description?: string | null;
};
export type EntityTypeFieldPageResponse = {
    data: EntityTypeFieldResource[];
    included?: JsonApiResource[] | null;
    meta: PageMeta;
    links: PageLinks;
};
export type BatchAddEntityTypeFieldsResultAttributes = {
    fields_created: number;
    fields_reactivated: number;
    fields_existing: number;
};
export type BatchAddEntityTypeFieldsResultResource = {
    type?: "entity-type-field-batch-add";
    id: string;
    attributes: BatchAddEntityTypeFieldsResultAttributes;
    relationships?: null;
};
export type BatchAddEntityTypeFieldsResultResponse = {
    data: BatchAddEntityTypeFieldsResultResource;
};
export type BatchAddEntityTypeFieldsRequest = {
    /** Entity type the fields are assigned to. */
    entity_type_id: string;
    /** Unified field ids to add (1..100). */
    uf_field_ids: string[];
};
export type EntityFieldValueBatchUpsertMeta = {
    /** Cells written. 0 when every cell in the batch was refused. */
    values_upserted: number;
};
export type EntityFieldValueBatchUpsertResultResponse = {
    meta: EntityFieldValueBatchUpsertMeta;
    /** One entry per refused cell, in request order. Absent on a full success (200); present on a partial success (207) and when every cell was refused (400). */
    errors?: ErrorData[] | null;
};
export type EntityFieldValueBatchUpsertErrorResponse = {
    errors: ErrorData[];
    meta?: EntityFieldValueBatchUpsertMeta | null;
};
export type BatchUpsertFieldValueItem = {
    /** UUID of the group (entity instance) this cell belongs to. */
    group_id: string;
    /** entity_type_field_id is the primary key (uuid) of the entity_type_field row representing the group column, not unified_field_id. */
    entity_type_field_id: string;
    /** Arbitrary JSON value stored in PostgreSQL JSONB and returned unchanged. Unified Fields values commonly use the shown data envelope. */
    value: any;
};
export type BatchUpsertFieldValuesRequest = {
    /** Cells to upsert across groups (1-1000). */
    items: BatchUpsertFieldValueItem[];
};
export type EntityFieldValueBatchDeleteResultAttributes = {
    values_deleted: number;
};
export type EntityFieldValueBatchDeleteResultResource = {
    type?: "entity-field-value-batch-delete";
    id: string;
    attributes: EntityFieldValueBatchDeleteResultAttributes;
    relationships?: null;
};
export type EntityFieldValueBatchDeleteResultResponse = {
    data: EntityFieldValueBatchDeleteResultResource;
};
export type BatchDeleteFieldValueItem = {
    /** UUID of the group (entity instance) this cell belongs to. */
    group_id: string;
    /** entity_type_field_id is the primary key (uuid) of the entity_type_field row representing the group column, not unified_field_id. */
    entity_type_field_id: string;
};
export type BatchDeleteFieldValuesRequest = {
    /** Cells to delete across groups (1-100). */
    items: BatchDeleteFieldValueItem[];
};
export type GroupAliasesItem = {
    /** Group id of the entity (from POST /groups/batch-add). */
    group_id: string;
    /** Alias variants that resolve to this group. Resolution is alias-only, so the group's own name may be included here. */
    aliases?: string[];
};
export type BatchAddResultAttributes = {
    nodes_created: number;
    nodes_existing: number;
};
export type BatchAddResultResource = {
    type?: "node-batch-add";
    id: string;
    attributes: BatchAddResultAttributes;
    relationships?: null;
};
export type BatchAddResultResponse = {
    data: BatchAddResultResource;
};
export type BatchAddNodeItem = {
    /** Type of the upstream resource. */
    resource_type: "ticket" | "ticket_v2" | "document";
    /** Unique identifier of the upstream resource. */
    resource_id: string;
};
export type EvisearchQuery = {
    provider: "evisearch";
    resource_type: "ticket" | "ticket_v2" | "document";
    query: any[];
};
export type BatchAddNodesRequest = {
    /** Node under which new nodes are created. */
    parent_node_id: string;
    /** Explicit list of resources to add (max 1000). Mutually exclusive with `query`. */
    items?: BatchAddNodeItem[];
    /** Query-based resource selection. Mutually exclusive with `items`. */
    query?: ({
        provider: "evisearch";
    } & EvisearchQuery) | null;
};
export type NodeResponse = {
    data: NodeResource;
};
export type UpdateNodeMetadataRequest = {
    /** Arbitrary JSON to store on the node. Pass null to clear all metadata. */
    metadata: {
        [key: string]: any;
    } | null;
};
export type BatchMoveNodesRequest = {
    /** List of node UUIDs to move (max 100) */
    node_ids?: string[];
    /** UUID of the new parent node */
    new_parent_node_id: string;
    /** If True, moves all non-root nodes in the group to the root node specified as the new parent */
    select_all?: boolean;
};
export type NodePathAttributes = {
    resource_type: ResourceType;
    resource_id: string;
    group_id: string | null;
    parent_node_id: string | null;
    created_at: string | null;
    updated_at: string | null;
    children_count?: number | null;
};
export type NodePathResource = {
    type?: "nodes";
    id: string;
    attributes: NodePathAttributes;
    relationships?: NodeRelationships | null;
};
export type NodePathResponse = {
    data: NodePathResource[];
};
export type NodePageResponse = {
    data: NodeResource[];
    included?: GroupResource[] | null;
    meta: PageMeta;
    links: PageLinks;
};
export type NodeIncludeType = "groups";
